import { Component, Input, ViewChild } from '@angular/core';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { SizeableDirective } from '../../directives/sizeable.directive';
import { CustomIconNames, CustomIconVariations } from '@core/types/icons.type';
import { CustomIconsRegisterService } from '@core/services/custom-icon-register.service';
import { Subscription } from 'rxjs';

type MatIconFontSets = 'material-icons' | 'material-symbols-outlined' | 'material-icons-outlined'  //| 'material-icons-round' | 'material-icons-sharp' | 'material-icons-two-tone';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  providers: [{ provide: SizeableDirective, useExisting: IconComponent }],
})
export class IconComponent extends SizeableDirective {
  @Input({ required: true })
  name: CustomIconNames | string = '';
  @Input()
  appearance: Exclude<CustomIconVariations, 'disabled'> = 'default';
  @Input()
  theme: 'dark' | 'light' = 'light';
  @Input()
  color?: string;
  @Input()
  matFontSet: MatIconFontSets = 'material-icons';

  protected fontIcon: string = '';
  protected svgIcon: string = '';
  protected filePath: string = '';



  private iconSubscription?: Subscription;

  constructor(private customIconRegister: CustomIconsRegisterService) {
    super();
  }

  ngOnInit() {
    this.prepareIcon();
  }

  override ngOnChanges() {
    this.prepareIcon();
  }

  ngOnDestroy() {
    this.iconSubscription?.unsubscribe();
  }

  private prepareIcon() {
    this.iconSubscription?.unsubscribe();

    if(this.isImageFilePath(this.name)) {
      this.filePath = this.name
    }else if (this.customIconRegister.hasIcon(this.name)) {
      this.iconSubscription = this.prepareCustomIconName().subscribe(
        (iconName: string) => {
          this.svgIcon = iconName;
        }
      );
    } else {
      this.fontIcon = this.name;
    }
  }

  private prepareCustomIconName() {
    let appearance: CustomIconVariations = this.appearance;

    if (this.disabled) appearance = 'disabled';

    return this.customIconRegister.getIcon$(
      this.name as CustomIconNames,
      appearance
    );
  }

  private isImageFilePath(path: string): boolean {
    return /\.(jpe?g|png|gif|bmp|webp|tiff|svg?)$/i.test(path);
  }
}
